import { Button, Modal, ModalBody } from "@ht/components";
import { forwardRef } from "react";
import Webcam from "react-webcam";
interface IProps {
    visible: boolean;
    onClose: () => void;
    onCapture: () => void;
}
export const CameraModal = forwardRef<Webcam, IProps>(({ visible, onClose, onCapture }, ref) => {
    return (<Modal className="!overflow-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100" size="lg"
        show={visible} onClose={onClose}>
        <ModalBody>
            <Button className="bg-primary border-none ml-1 rounded-l-lg absolute right-8 top-0 m-2 z-10">
                <span className="fa fa-camera" role="presentation" onClick={onCapture}></span>
            </Button>
            <Button onClick={onClose} color="secondary"
                className="border-none ml-1  rounded-r-lg absolute right-0 top-0 m-2 z-10">
                <span className="fa fa-times"></span>
            </Button>
            <div className="overflow-auto h-[90vh] rounded-lg scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                <Webcam className="w-full h-full rounded-lg"
                    audio={false}
                    ref={ref}
                    videoConstraints={{
                        facingMode: "user"
                    }}
                    screenshotFormat="image/jpeg"
                />
            </div>
        </ModalBody>
    </Modal>);
})

CameraModal.displayName = "camera-modal"